module.exports = __webpack_public_path__ + "img/isbank.41f03813.png";